export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ko.22fe17aebe7281f4.json"